import '../stylesheets/flashes';
import Vue from 'vue/dist/vue.esm';

$(function () {
  if ($('#search-conditions').length) {
    new Vue({
      el: '#search-conditions',
      methods: {
        getCurrentYear() {
          return (new Date()).getFullYear();
        },
        getCurrentMonth() {
          return (new Date()).getMonth() + 1;
        },
        getYear() {
          return this.$refs.year.value;
        },
        getMonth() {
          return this.$refs.month.value;
        },
        onYearChanged() {
          if (this.isSubmittable()) {
            this.submit();
          } else {
            this.updateMonths();
          }
        },
        onMonthChanged() {
          this.trySubmit();
        },
        onItemTypeChanged() {
          this.trySubmit();
        },
        isSubmittable() {
          return (this.getYear() != '' && this.getMonth() != '');
        },
        trySubmit() {
          if (this.isSubmittable()) {
            this.submit();
          }
        },
        submit() {
          this.$refs.form.submit();
        },
        updateMonths() {
          const monthNode = this.$refs.month;
          for (let i = 0; i < monthNode.options.length; i++) {
            const option = monthNode.options[i];
            const month = parseInt(monthNode.options[i].value);
            if (isNaN(month)) {
              continue;
            }
            option.disabled = !this.isSelectable(month);
          }
        },
        isSelectable(month) {
          const year = this.getYear();
          const currentYear = this.getCurrentYear();

          if (year < currentYear) {
            return true;
          } else if (year == currentYear) {
            return month <= this.getCurrentMonth();
          } else {
            return false;
          }
        },        
      },
      mounted() {
        this.updateMonths();
      },
    });
  }
  $('.btn-tab-btn span').on('click', function() {
    const index = $(this).index();
    $('[name="view"]').val('view' + index);
    $(this).parent().find('span').addClass('on')
      .eq(index).removeClass('on');
    $('.btn-tab-label span').removeClass('on')
      .eq(index).addClass('on');
    $('.btn-tab-contents > li').removeClass('on')
      .eq(index).addClass('on');
  });
});

